'use strict';

require('public/css/privacy-request.scss');

const { initPrivacyRequestConsentControls } = require('./lib/privacy-request/consent');

function revealDefaultRightsPanel(root) {
	const formCard = root.querySelector('[data-privacy-request-form-card]');
	if (formCard instanceof HTMLElement) {
		formCard.hidden = true;
	}

	const rightsPanel = root.querySelector('[data-privacy-request-rights-panel]');
	if (rightsPanel instanceof HTMLElement) {
		rightsPanel.hidden = false;
	}

	const panels = root.querySelectorAll('[data-privacy-request-panel]');
	panels.forEach(function (panel) {
		if (!(panel instanceof HTMLElement)) {
			return;
		}

		panel.hidden = panel.dataset.privacyRequestPanel !== 'us';
	});
}

function bootPrivacyRequestPage() {
	const root = document.querySelector('[data-privacy-request-page]');
	if (!(root instanceof HTMLElement)) {
		return;
	}

	root.classList.add('privacy-request-page--figma');
	revealDefaultRightsPanel(root);
	initPrivacyRequestConsentControls(root);
}

if (typeof rp$ === 'function') {
	rp$(document).ready(bootPrivacyRequestPage);
} else if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', bootPrivacyRequestPage);
} else {
	bootPrivacyRequestPage();
}
